import { EntityScopeEnum } from '@docma-mm-core/entity/entity-scope.enum';
import { User } from '@docma-mm-core/user/user';
import { LayoutField } from './layout-field';
import {LayoutFilter} from '@docma-mm-core/layout/layout-filter';
import { Project } from '@docma-mm-core/project/project';

export class Layouts {
  Data: Layout[];
  Count: number;
}

export class Layout {
  Id?: number;
  SUid?: string;
  Name?: string;
  Description?: string;
  User?: User;
  Project?: Project;
  Scope?: EntityScopeEnum;
  Fields?: LayoutField[];         /* USERFIELDS FOR AG-GRID... */
  LayoutFields?: LayoutField[];
  LayoutFilters?: LayoutFilter[];
  HasFilter?: boolean;
  ForbiddenFilterFields?: string[];   /* FIELD DEFAULT_NAMES */
  FilterDisabled?: boolean;
  IsFavoriteAll?: boolean;
  IsFavoriteUser?: boolean;
  IsVisibleForCO?: boolean;
  IsVisibleForCT?: boolean;
  IsVisibleForSC?: boolean;
  IsOverviewLayout?: boolean;
}
